<template>
<v-container
  class="containner_carousel"
  :class="{ 'w-100': viewHtml === 'home', 'w-70': viewHtml === 'login' }">
  <span v-bind:class="{ 'btn_carousel': true, 'hidden': !showPrev }" @click="prevSlide">
    <v-icon class="btn__car__icon">mdi-chevron-left</v-icon>
  </span>
  <div class="wrapper_car">
    <v-carousel ref="carousel" cycle hide-delimiters :interval="7000" v-model="currentIndex">
      <v-carousel-item v-for="(item, index) in marqueeItems" :key="index">
        <div class="carousel-caption d-md-block">
          <v-btn
            class="primary--text"
            text
            icon
            :href="enLogin ? '/pulsodigital' : null"
            :to="!enLogin ? '/pulsodigital' : null"
            :target="enLogin ? '_blank' : null"
            rel="noopener noreferrer"
          >
            <v-icon>icon-ayudadigital-pulsodigital-negativo</v-icon>
          </v-btn>
          <span v-html="item.name" />
          <span
            class="link__suscriptor"
            v-if="viewHtml === 'home' &&
              item &&
              item.listApps &&
              item.listApps.length > 0"
          >
            <a @click="suscriptorAplication(item.listApps)" >
              {{ $t('components.carouselMarquee.link') }}
            </a>
          </span>
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
  <span v-bind:class="{ 'btn_carousel': true, 'hidden': !showNext }" @click="nextSlide">
    <v-icon class="btn__car__icon">mdi-chevron-right</v-icon>
  </span>
</v-container>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    applications: {
      type: Array,
      default: () => ([]),
    },
    listitems: {
      type: Array,
      default: () => ([]),
    },
    viewHtml: {
      type: String,
      default: () => ([]),
    },
  },
  data() {
    return {
      currentIndex: 0,
      isOnlyOne: false,
    };
  },
  computed: {
    showPrev() {
      return this.currentIndex !== 0 && !this.isOnlyOne;
    },
    showNext() {
      return this.currentIndex !== this.items.length - 1 && !this.isOnlyOne;
    },
    marqueeItems() {
      if (this.items.length === 1) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isOnlyOne = true;
        return [this.items[0], this.items[0], this.items[0]];
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.isOnlyOne = false;

      return this.items;
    },
    enLogin() {
      return window.location.pathname.includes('/login');
    },
  },
  methods: {
    prevSlide() {
      this.$refs.carousel.prev();
    },
    nextSlide() {
      this.$refs.carousel.next();
    },
    async suscriptorAplication(item) {
      if (item.length < 1) return;

      this.$router.push({
        name: 'ConfigurationApplications',
        params: { applications: item },
      });
    },
  },
  created() {
    this.suscripcionesClient = this.$api.getClient('suscripciones');

    if (this.items.length === 1) {
      this.isOnlyOne = true;
    }
  },
};
</script>

<style>
div#announcements-carousel{
  z-index: 999;
}
.containner_carousel{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: white;
  padding: 0;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14),
    0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.w-70 {
  width: 70% !important;
}
.w-100 {
  width: 100% !important;
}
.wrapper_car {
  margin-left: -5px !important;
  padding: 0.5rem 0;
  height: fit-content !important;
  width: 100%;
}
.wrapper_car .v-window.v-item-group.theme--dark.v-carousel{
  height: fit-content !important;
}
.wrapper_car .v-image.v-responsive{
  display: flex;
  align-items: center;
}
.wrapper_car .v-image{
  height: fit-content !important;
}
.carousel-caption.d-md-block{
  display: flex !important;
  align-items: center;
}
.btn_carousel {
  background-color: transparent !important;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  color: #27846d !important;
}
.btn__car__icon {
  color: #27846d !important;
}
.iconn__carousel {
  font-size: 2rem;
  margin: 0 0.7rem 0 0.2rem;
  color: #27846d;
}
.icon-btn:hover {
  background-color: transparent !important;
}

.v-window__prev, .v-window__next {
  display: none;
}
.hidden {
  visibility: hidden;
}
.link__suscriptor {
  margin-left: 4px;
}

@media (max-width: 600px) {
  .containner_carousel{
    width: 100% !important;
  }
}

</style>
